const allLocations = [
    "Airport", "Aquarium", "Art Gallery", "Auto Showroom", "Baseball Stadium",
    "Bakery", "Bank Vault", "Barbershop", "Barn", "Beach", "Bedroom", "Beehive", "Bell Tower",
    "Bike Shop", "Botanical Garden", "Bowling Alley", "Boxing Ring", "Bridge", "Buffet Restaurant", "Burger Joint",
    "Butcher Shop", "Cafe", "Car Dealership", "Casino", "Castle", "Catacombs", "Cemetery Gate",
    "Chess Club", "Chocolate Factory", "Church", "Circus",
    "Coffee Shop", "Conference Center", "Construction Yard", "Convenience Store", "Cooking School",
    "Coral Reef", "Cow Farm", "Cruise Ship", "Dance Studio", "Diner", "Disco Club", "Dog Park", "Dollhouse",
    "Fire Station", "Fishing Pier", "Food Truck", "Forest",
    "Furniture Store", "Garage", "Gas Station Rest Stop", "Golf Course", "Greenhouse", "Grocery Store",
    "Haunted House", "Harbor", "High School",
    "Jewelry Store", "Junkyard", "Karaoke Bar", "Kiosk",
    "Lighthouse", "Local Market", "Luxury Hotel", "Mall", "Marina", "Massage Parlor", "Movie Theater", "Music Festival",
    "Opera House", "Outdoor Cafe", "Park Bench", "Pet Store", "Pizzeria",
    "Playground", "Amusement Park", "Art Museum", "Bank", "Beach", "Broadway Theater", "Candy Factory", "Casino", "Cat Show",
    "Cathedral", "Cemetery", "Circus Tent", "Coal Mine", "Construction Site", "Corporate Party", "Crusader Army", "Day Spa",
    "Embassy", "Gaming Convention", "Gas Station", "Harbor Docks", "Hospital", "Hotel", "Ice Hockey Stadium", "Jail", "Jazz Club",
    "Library", "Military Base", "Movie Studio", "Night Club", "Ocean Liner", "Passenger Train", "Pirate Ship", "Polar Station",
    "Police Station", "Race Track", "Restaurant", "Retirement Home", "Rock Concert", "School", "Service Station", "Sightseeing Bus",
    "Space Station", "Stadium", "Submarine", "Subway", "Supermarket", "University", "Vineyard", "Wedding", "Zoo"
  ];
  
  export default allLocations;
  